import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { AGENCY_UPDATESTATUS_INIT_LOADING, AGENCY_UPDATESTATUS_INIT_SUCCESS, AGENCY_UPDATESTATUS_INIT_FAIL } from '@/store/types'

export const updateStatus = {
  async agencyQuoteUpdateStatusInit({ commit, state }) {
    // reset quotation state (prevent dirty data)
    if (state.updateStatus.init !== 1) {
      const apiUrl = state.menu.updateStatus
      if (apiUrl) {
        commit(AGENCY_UPDATESTATUS_INIT_LOADING)
        try {
          const result = await http.get(apiUrl)
          if (result.data) {
            const { data } = result.data
            if (data) {
              const menu = extractMenu(result.data._links)
              const commitResult = {
                menu: menu,
                statusList: data.statusList
              }
              commit(AGENCY_UPDATESTATUS_INIT_SUCCESS, commitResult)
            }
          }
        } catch (error) {
          commit(AGENCY_UPDATESTATUS_INIT_FAIL, extractMessages(error))
        }
      } else {
        commit(AGENCY_UPDATESTATUS_INIT_FAIL, ['Invalid API URL'])
      }
    }
  }
}
